import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthShell, FormError } from "@/components/AuthForm";
import { LegalConsent } from "@/components/LegalConsent";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError, type User } from "@/lib/api";

const fmt = (iso: string) => iso.split("-").reverse().join("/");

export default function LegalAcceptPage({ user }: { user: User }) {
  const { refresh, logout } = useAuth();
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const legal = user.legal!;

  const accept = async () => {
    if (!checked) return setError("Marca la casilla para continuar");
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/accept-legal", { terms_version: legal.terms_version, privacy_version: legal.privacy_version });
      await refresh();
    } catch (err) {
      setError(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Actualizamos nuestros textos legales" subtitle="Para seguir usando Otium, revisa y acepta la versión vigente.">
      <div className="space-y-5" data-testid="legal-accept-gate">
        <ul className="space-y-1 text-sm text-slate-600">
          <li data-testid="legal-accept-terms-version">Términos y Condiciones: versión del {fmt(legal.terms_version)}</li>
          <li data-testid="legal-accept-privacy-version">Aviso de Privacidad: versión del {fmt(legal.privacy_version)}</li>
        </ul>
        <LegalConsent checked={checked} onChange={setChecked} testId="legal-accept-checkbox" />
        <FormError message={error} testId="legal-accept-error" />
        <Button onClick={accept} disabled={loading} className="h-11 w-full bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" data-testid="legal-accept-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aceptar y continuar"}
        </Button>
        <button type="button" onClick={logout} className="w-full text-center text-sm text-slate-500 underline-offset-4 hover:underline" data-testid="legal-accept-logout">
          Cerrar sesión
        </button>
      </div>
    </AuthShell>
  );
}
